import React from 'react'

class Footer extends React.Component {
    render() {
        return (
            <div id="footer">
                <div className="inner">
                    <ul className="icons">
                        <li><a href="https://twitter.com/aguwatudde" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
                        <li><a href="https://github.com/AGMETEOR" className="icon fa-github"><span className="label">Github</span></a></li>
                    </ul>
                    <ul className="copyright">
                        <li>Built with: <a href="https://www.gatsbyjs.org/">Gatsby JS</a></li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default Footer
